/**
 * A marker sliding along a timeline, and the timeline's own progress.
 *
 * Used by the fencing-token figure, where the point is *ordering*: which holder
 * was current when. Under reduced motion the playhead sits at the moment the
 * figure is arguing about — the fence being refused — because that instant is
 * the content, not the sweep towards it.
 */
import { m } from 'motion/react'

import { useInViewOnce } from './useInViewOnce'
import { useReducedMotionSafe } from './motion'

export function Playhead({
  /** 0–1: where the argument is. Also the parked position. */
  at,
  duration = 1.8,
  delay = 0,
  className = 'kl-playhead',
}: {
  at: number
  duration?: number
  delay?: number
  className?: string
}) {
  const reduced = useReducedMotionSafe()
  const [ref, seen] = useInViewOnce<HTMLDivElement>()
  const pct = `${Math.max(0, Math.min(1, at)) * 100}%`

  if (reduced) return <div className={className} style={{ left: pct }} aria-hidden="true" />

  return (
    <m.div
      ref={ref}
      className={className}
      aria-hidden="true"
      initial={{ left: '0%' }}
      animate={{ left: seen ? pct : '0%' }}
      transition={{ duration, delay, ease: [0.32, 0.72, 0, 1] }}
    />
  )
}
